import { AppConfiguration } from '../';

export interface PublicConfiguratorApi {
  init(configuration: AppConfiguration): void;
  updateConfiguration(configuration: AppConfiguration): void;
  close(maintainState?: boolean, callback?: () => void): void;
}
